/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Messaging_Bots_Support_Title7Inputs */

const en_svc_messaging_bots_support_title7 = /** @type {(inputs: Svc_Messaging_Bots_Support_Title7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FAQ and support`)
};

const ar_svc_messaging_bots_support_title7 = /** @type {(inputs: Svc_Messaging_Bots_Support_Title7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الأسئلة الشائعة والدعم`)
};

const bn_svc_messaging_bots_support_title7 = /** @type {(inputs: Svc_Messaging_Bots_Support_Title7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FAQ ও সাপোর্ট`)
};

const de_svc_messaging_bots_support_title7 = /** @type {(inputs: Svc_Messaging_Bots_Support_Title7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FAQ und Support`)
};

const es_svc_messaging_bots_support_title7 = /** @type {(inputs: Svc_Messaging_Bots_Support_Title7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preguntas frecuentes y soporte`)
};

const fr_svc_messaging_bots_support_title7 = /** @type {(inputs: Svc_Messaging_Bots_Support_Title7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FAQ et support`)
};

const pt_svc_messaging_bots_support_title7 = /** @type {(inputs: Svc_Messaging_Bots_Support_Title7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perguntas frequentes e suporte`)
};

const zh_svc_messaging_bots_support_title7 = /** @type {(inputs: Svc_Messaging_Bots_Support_Title7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`问答与客服`)
};

const tr_svc_messaging_bots_support_title7 = /** @type {(inputs: Svc_Messaging_Bots_Support_Title7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SSS ve destek`)
};

const ru_svc_messaging_bots_support_title7 = /** @type {(inputs: Svc_Messaging_Bots_Support_Title7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FAQ и поддержка`)
};

const pl_svc_messaging_bots_support_title7 = /** @type {(inputs: Svc_Messaging_Bots_Support_Title7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FAQ i wsparcie`)
};

/**
* | output |
* | --- |
* | "FAQ and support" |
*
* @param {Svc_Messaging_Bots_Support_Title7Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_messaging_bots_support_title7 = /** @type {((inputs?: Svc_Messaging_Bots_Support_Title7Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Messaging_Bots_Support_Title7Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_messaging_bots_support_title7(inputs)
	if (locale === "bn") return bn_svc_messaging_bots_support_title7(inputs)
	if (locale === "de") return de_svc_messaging_bots_support_title7(inputs)
	if (locale === "es") return es_svc_messaging_bots_support_title7(inputs)
	if (locale === "fr") return fr_svc_messaging_bots_support_title7(inputs)
	if (locale === "pt") return pt_svc_messaging_bots_support_title7(inputs)
	if (locale === "zh") return zh_svc_messaging_bots_support_title7(inputs)
	if (locale === "tr") return tr_svc_messaging_bots_support_title7(inputs)
	if (locale === "ru") return ru_svc_messaging_bots_support_title7(inputs)
	if (locale === "pl") return pl_svc_messaging_bots_support_title7(inputs)
	return en_svc_messaging_bots_support_title7(inputs)
});
export { svc_messaging_bots_support_title7 as "svc_messaging-bots_SUPPORT_title" }